const ls = {
  get(name) {
    return localStorage.getItem(name);
  },
  set(name, value) {
    localStorage.setItem(name, value);
  },
  remove(name) {
    localStorage.removeItem(name);
  },
  updateAppSettings(newValue) {
    localStorage.setItem('pdd-settings', JSON.stringify(newValue));
  },
  initAppSettings() {
    if (!localStorage.getItem('pdd-settings')) {
      localStorage.setItem('pdd-settings', JSON.stringify({
        ticketResults: [],
        themeResults: [],
        examResults: [],
        constructorResults: [],
      }));
    }
  },
};

export default ls;
